import { SuccessResponse } from "@nib/nib-api-models";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { Store } from "src/components/Context/store-context";
import { useAppAuth } from "src/hooks/useAppAuth";

type SavedAnswers = Partial<Store>;

export const useSavedAnswers = () => {
  const { personId, isAuthenticated, getAccessTokenSilently } = useAppAuth();

  return useQuery({
    queryKey: ["savedAnswers", personId],
    enabled: isAuthenticated,
    queryFn: async () => {
      const cached = sessionStorage.getItem(`store:${personId}`);
      if (cached) {
        return JSON.parse(cached) as SavedAnswers;
      }

      const response = await axios.get<SuccessResponse<SavedAnswers>>(
        `${process.env.GATSBY_HEALTH_SERVICES_API_URL}/recommendations/sra`,
        {
          headers: {
            Authorization: `Bearer ${await getAccessTokenSilently()}`,
          },
        }
      );

      return response.data.data;
    },
  });
};
